export enum RequestStatus {
  Waiting = 1,
}

export enum PrzpRequestStatus {
  Registered = 'ZAREJESTROWANE',
}
